module.exports = __webpack_public_path__ + "static/tulsa-5-bfb92c5b2694d53cfd46a8cfa7969b64.jpg";